// Shared helpers and constants for Messages pages
export const TABS = [
  { id: "all", label: "All" },
  { id: "sent", label: "Sent" },
  { id: "received", label: "Received" },
  { id: "scheduled", label: "Scheduled" },
  { id: "drafts", label: "Drafts" },
];

export function tabToStatus(tabId) {
  switch (tabId) {
    case "all":
      return 0;
    case "sent":
      return 1;
    case "received":
      return 4;
    case "scheduled":
      return 2;
    case "drafts":
      return 3;
    default:
      return 0;
  }
}

export function formattedDate(orgDate) {
  if (!orgDate) return "";
  const originalDate = new Date(orgDate);
  const yesterday = () => {
    let d = new Date();
    d.setDate(d.getDate() - 1);
    return d;
  };
  const currentDate = new Date().toISOString().split("T")[0];
  const yesterdayDate = yesterday().toISOString().split("T")[0];
  const scheduledDate = String(orgDate).split("T")[0];

  const month = originalDate.getMonth() + 1;
  const date = originalDate.getDate();
  const year = originalDate.getFullYear();
  const formattedTime = originalDate.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  if (scheduledDate === currentDate) return formattedTime;
  if (scheduledDate === yesterdayDate) return "Yesterday";
  return `${month}/${date}/${year}`;
}

export function getInitials(name) {
  const cleanName = (name || "")
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .replace(/\s+/g, " ")
    .trim();
  if (!cleanName) return "";
  const initials = cleanName
    .split(" ")
    .filter(Boolean)
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return initials || "";
}

export function alertTypeName(alertTypeValue, alertTypes) {
  if (Array.isArray(alertTypes) && alertTypes.length) {
    return (
      alertTypes.find((a) => a.value === alertTypeValue)?.label || "Other"
    );
  }
  switch (alertTypeValue) {
    case 1:
      return "Voice";
    case 2:
      return "Email";
    case 3:
      return "SMS";
    default:
      return "Other";
  }
}

export function alertIcon(alertTypeValue, fallbackClass = "fa fa-mobile") {
  switch (alertTypeValue) {
    case 1:
      return "fa fa-microphone";
    case 2:
      return "fa fa-envelope";
    case 3:
      return "fa fa-mobile";
    default:
      return fallbackClass;
  }
}

export function formatDescription(str = "", wordCount = 10) {
  return (str || "").split(" ").slice(0, wordCount).join(" ");
}
